
import React from 'react';
import { 
  LayoutDashboard, 
  Users, 
  Settings 
} from 'lucide-react';

interface BottomNavProps {
  currentView: string;
  setView: (view: any) => void;
}

const BottomNav: React.FC<BottomNavProps> = ({ currentView, setView }) => {
  const items = [
    { id: 'dashboard', label: 'Home', icon: LayoutDashboard },
    { id: 'clients', label: 'Clients', icon: Users },
    { id: 'settings', label: 'Settings', icon: Settings },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-md border-t border-slate-200 flex justify-around items-center px-4 pt-3 pb-[calc(env(safe-area-inset-bottom)+1rem)] z-50 shadow-[0_-8px_30px_rgb(0,0,0,0.04)]">
      {items.map((item) => {
        const isActive = currentView === item.id || 
          (item.id === 'clients' && (currentView === 'client-detail' || currentView === 'timesheet'));
        
        return (
          <button
            key={item.id}
            onClick={() => setView(item.id)}
            className={`flex flex-col items-center gap-1.5 transition-all duration-200 ${
              isActive ? 'text-blue-600' : 'text-slate-400'
            }`}
          >
            <div className={`p-2.5 rounded-2xl transition-colors ${isActive ? 'bg-blue-50' : ''}`}>
              <item.icon size={26} strokeWidth={isActive ? 3 : 2} />
            </div>
            <span className={`text-[9px] font-black uppercase tracking-widest ${isActive ? 'opacity-100' : 'opacity-60'}`}>
              {item.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
};

export default BottomNav;
